import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { authorizationStore as store } from "../../../features/authorization/authorization_store";
import { AccessDenied } from "../../../features/authorization/session_controls";
export const PrivateRouter = observer((props: { children?: JSX.Element | JSX.Element[] }) => {
  useEffect(() => { void store.restore(); }, []);
  if (!store.isInitialized || store.isLoading) return <div role="status">Проверяем вход…</div>;
  if (store.errorMessage && !store.user) return <div role="alert">{store.errorMessage} <button onClick={() => store.retry()}>Повторить</button></div>;
  if (!store.user) return <Navigate to="/auth" replace />;
  if (store.user.role !== "admin") return <AccessDenied />;
  return <>{props.children}</>;
});
